// ============================================================================
// PORTAL CONTEXT REPOSITORY
// ARQUIVO: src/services/PortalContextRepository.js
// RESPONSABILIDADE: Operações Firestore do PortalContext (busca de cliente, workspaces).
// Criado: Fase 6.3 — mover Firestore direto de PortalContext.jsx para repositório.
// ============================================================================

import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const APP_ID = FIREBASE_CONFIG?.projectId || '';

/** Busca cliente por ID (preview mode ou sessionStorage). */
export async function fetchClientById(clientId) {
  if (!clientId || !APP_ID) return null;
  try {
    const snap = await getDoc(doc(db, 'artifacts', APP_ID, 'public', 'data', 'clients', clientId));
    if (snap.exists()) {
      return { id: snap.id, ...(snap.data() || {}) };
    }
  } catch { /* noop */ }
  return null;
}

/** Busca clientes por email (coleção legacy 'clients'). */
export async function fetchClientsByEmail(email) {
  if (!email) return [];
  const hits = [];
  try {
    const ref = collection(db, 'clients');
    const q = query(ref, where('email', '==', email));
    const snap = await getDocs(q);
    snap.docs.forEach((d) => {
      const data = d.data() || {};
      if (data.isDeleted === true) return;
      if (!hits.find((h) => h.id === d.id)) {
        hits.push({ ...data, id: d.id, _firestoreId: d.id });
      }
    });
  } catch { /* noop */ }
  return hits;
}

/** Busca clientes por contact.email (coleção artifacts). */
export async function fetchClientsByContactEmail(email) {
  if (!email || !APP_ID) return [];
  const hits = [];
  const tryEmails = [email];
  const lower = email.toLowerCase();
  if (lower !== email) tryEmails.push(lower);

  try {
    const ref = collection(db, 'artifacts', APP_ID, 'public', 'data', 'clients');
    for (const probe of tryEmails) {
      const q = query(ref, where('contact.email', '==', probe));
      const snap = await getDocs(q);
      snap.docs.forEach((d) => {
        const data = d.data() || {};
        if (data.isDeleted === true) return;
        if (!hits.find((h) => h.id === d.id)) {
          hits.push({ ...data, id: d.id, _firestoreId: d.id });
        }
      });
    }
  } catch { /* noop */ }
  return hits;
}

/** Busca workspaces (clientes vinculados) por anchor.id. */
export async function fetchWorkspacesByAnchor(anchorId) {
  if (!anchorId || !APP_ID) return [];
  const hits = [];
  const dedup = (d) => !hits.find((h) => h.id === d.id);

  try {
    const ref = collection(db, 'artifacts', APP_ID, 'public', 'data', 'clients');
    const snap = await getDocs(query(ref, where('anchor.id', '==', anchorId)));
    snap.docs.forEach((d) => {
      const o = { id: d.id, ...(d.data() || {}) };
      if (dedup(o)) hits.push(o);
    });
  } catch { /* noop */ }

  try {
    const ref = collection(db, 'clients');
    const snap = await getDocs(query(ref, where('anchor.id', '==', anchorId)));
    snap.docs.forEach((d) => {
      const o = { id: d.id, ...(d.data() || {}) };
      if (dedup(o)) hits.push(o);
    });
  } catch { /* noop */ }

  return hits;
}
